import { render, staticRenderFns } from "./BoxInformation.vue.html?vue&type=template&id=20b69ba8&scoped=true&"
import script from "./BoxInformation.component.js?vue&type=script&lang=vueJs&"
export * from "./BoxInformation.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BoxInformation.scoped.scss?vue&type=style&index=0&id=20b69ba8&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b69ba8",
  null
  
)

export default component.exports